import { MachineDashboard } from 'app/modules/cleaning/widgets/machine-dashboard/components/MachineDashboard/MachineDashboard';

export const MachineDashboardPage = (): JSX.Element => <MachineDashboard />;
